module.exports = __webpack_public_path__ + "0237c712552eed0581abe4f6e02e52d6.svg";